// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"tooltip_Tooltip__gs8zq"};